





import Vue from 'vue';
import axios from 'axios';
import api from '../api';
import PatientList from '../components/PatientList.vue';
export default Vue.extend({
  name: 'Patients',
  data() {
    return {};
  },

  beforeRouteLeave (to, from , next) {
    // 跳转到"诊断编辑页面"或者"患者历史诊断详情页面"时，缓存患者列表页面
    // console.log("In patient beforeRouteLeave, to.name:",to.name);
    // || to.name == 'details'){
    if (to.name == 'Intell') {
      this.$route.meta.keepAlive = true;
      // console.log("In patient, beforeRouteLeave,keepAlive = true")
    // 跳转到其他页面时，不缓存患者列表页面
    }else{
      // console.log("In patient, beforeRouteLeave,keepAlive = false")
      this.$route.meta.keepAlive = false;
    }
    next();
  },
  // beforeRouteEnter (to, from, next) {
  //   console.log('In patient, beforeRouteEnter,to:',to, ", from:",from);
  // },
  // activated() {
  //   console.log("In patients, activated.");
  // },
  // mounted() {
  //   console.log("In patients, mounted.");
  // },
  // created() {
  //   console.log('In patients, created')
  // },

  components: {
    PatientList
  }
});
